import { Box, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

type BlockLandHeaderProps = {
    onClose: () => void;
    title?: string;
    infoText?: string;
};

const BlockLandHeader = ({
    onClose,
    title = "Block Land",
    // eslint-disable-next-line max-len
    infoText = "You can block a land up to 2 times per verification. Blocking will result in freezing all funds and currency generated from the land. Please make sure you have valid reasoning and evidence before blocking."
}: BlockLandHeaderProps) => {
    return (
        <Box
            sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: "12px",
                position: "relative",
                mb: "16px",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                }}
            >
                <Typography
                    sx={{
                        fontFamily: "'Inter', sans-serif",
                        fontSize: "18px",
                        fontWeight: 700,
                        color: "black",
                        lineHeight: "normal",
                    }}
                >
                    {title}
                </Typography>
                <IconButton
                    onClick={onClose}
                    sx={{
                        padding: 0,
                        width: "20px",
                        height: "20px",
                        color: "#1D1B20",
                        "&:hover": {
                            backgroundColor: "rgba(0, 0, 0, 0.04)",
                        },
                    }}
                >
                    <CloseIcon sx={{ fontSize: "20px" }} />
                </IconButton>
            </Box>

            <Box sx={{
                backgroundColor: "#d1efff",
                borderRadius: "12px",
                padding: "12px 16px",
                border: "1px solid #d1efff",
            }}>
                <Typography
                    sx={{
                        fontFamily: "'Inter', sans-serif",
                        fontSize: "14px",
                        fontWeight: 400,
                        color: "#333",
                        lineHeight: "1.5",
                    }}
                >
                    {infoText}
                </Typography>
            </Box>
        </Box>
    );
};

export default BlockLandHeader;
